// import FilterRow, {
//     FilterRowProps,
// } from "@/components/UtilitiesComponent/FilterRow";
// import assest from "@/json/assest";
import assest from "../../json/assest";

import React from "react";
import styles from "../../styles/pages/home.module.scss";
import styles1 from "../../styles/components/Filter.module.scss";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";

const Filter = (props) => {
  const { hideApprovedTab, approvedTabName, filterRowProps, className } = props;
  return (
    // <Box className={styles.table_sec}>
    //   <Box className={styles.table_top}>
    //             <FilterRow
    //                 {...filterRowProps}
    //                 FilterModalComponent={AllPurchasedFilterModal}
    //                 filterModalProps={{
    //                     hideBottom: true,
    //                 }}
    //             />
    //         </Box>
    //   <Box className={styles.table_main}>
    //     <Box className={styles1.emptyTable}>
    //       <Box className={styles1.emptyTableImg}>
    //         <img src={assest.searchIcon} width={45} height={45} alt="" />
    //       </Box>
    //       <p>We couldn’t find any matches for the selected filter(s).</p>
    //       <Button onClick={props?.resetFilters}>Reset filters</Button>
    //     </Box>
    //   </Box>
    // </Box>
    <Box className={`${styles1.emptyTable} tr-autoheight`}>
      <Box className={`${className}`}>
        <Box className={`${styles1.emptyTableImg} empty_table_imgs`}>
          <img src={assest.searchIcon} alt="" />
        </Box>
        <p>We couldn’t find any matches for the selected filter(s).</p>
        <Button onClick={props?.resetFilters} className="reset_filters">Reset filters</Button>
      </Box>
    </Box>
  );
};

export default Filter;
